"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var text = _ref.palette.text,
    shade = _ref.utils.shade;
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 140,
      borderRight: "1px solid ".concat(shade(text.primary, 2))
    }
  };
}, {
  name: 'StaticRangeButtons'
});
exports.useStyles = useStyles;